module.exports = __webpack_public_path__ + "static/img/JOSH_HAZLEWOOD.029c204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOSH_HAZLEWOOD.jpg
// module id = xzHA
// module chunks = 0